"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvailableFilterVariantsByCategoryErrors = void 0;
var UseCaseError_1 = require("../../../../models/concrete/UseCaseError");
exports.getAvailableFilterVariantsByCategoryErrors = [
    UseCaseError_1.UseCaseError.create('invalidData'),
    UseCaseError_1.UseCaseError.create('notFound'),
    UseCaseError_1.UseCaseError.create('problemInProcess')
];
//# sourceMappingURL=getAvailableFilterVariantsByCategoryErrors.js.map